import { Box, Grid, useMediaQuery, useTheme } from '@material-ui/core';
import { OrangeButton } from 'components/Button';
import ItemEmptyState from 'components/ItemEmptyState';
import { StyledCaptionsBase } from 'components/MenuItem/styles';
import Modal from 'components/Modal';
import AgreementClaim from 'components/Refunds/AgreementClaim';
import ClosedClaim from 'components/Refunds/ClosedClaim';
import ComplementaryInfoClaim from 'components/Refunds/ComplementaryInfoClaim';
import ContreVisit from 'components/Refunds/ContreVisit';
import PecCanceledClaim from 'components/Refunds/PecCanceledClaim';
import PecClaim from 'components/Refunds/PecClaim';
import Pending from 'components/Refunds/Pending';
import RejectedClaim from 'components/Refunds/RejectedClaim';
import RejectedRegulationClaim from 'components/Refunds/RejectedRegulationClaim';
import ValidatedClaim from 'components/Refunds/ValidatedClaim';
import messages from 'components/Refunds/messages';
import {
  COLOR_BY_REFUND_STATUS,
  StyledDropZoneContainer,
  StyledShortBody,
  StyledShortBody14,
} from 'components/Refunds/styles';
import { LongBody, ShortBody } from 'components/Typography';
import { REFUND_STATUSES } from 'constants/amcStatuses';
import {
  ImageWrapper,
  PrimaryTitleCard,
} from 'containers/AMCDashboard/DeclareFolderProcess/styles';
import {
  StyledCard,
  StyledGrid,
} from 'containers/AUTODashboard/Body/LastSinister/styles';
import { StyledAccordion } from 'containers/AmcDetailsPage/MyRefundsTab/Refunds/styles';
import { downloadFile } from 'helpers/fileUtils';
import { translate } from 'helpers/intl';
import useDownloadPdf from 'hooks/sinister/useDownloadPdf';
import { AssuranceIcon } from 'images';
import { get } from 'lodash';
import { DropzoneAreaBase, FileObject } from 'material-ui-dropzone';
import React, { useEffect } from 'react';
import { IntlShape, injectIntl, useIntl } from 'react-intl';
import { connect, useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { getContractAMCSelector } from 'store/contract/selectors';
import { setToasterOpen } from 'store/global/actions';
import { CI_MAX_FILES, DEFAULT_CI_FILES } from 'store/global/constants';
import {
  SinisterDemandTypeCode,
  checkExistMissingDocumentsRequestApi,
  submitCIApi,
} from 'store/sinistre/api';
import { getRefundAMCDetailsSelector } from 'store/sinistre/selectors';
import { userSelector } from 'store/user/selectors';
import styled from 'styled-components';
import {
  PHYSIQUE_DOCS,
  asyncForEach,
  blobToBase64,
  compress,
} from 'utils/amcUtils';
import breakpoints from 'utils/breakpoints';
import formatBytes from 'utils/formatBytes';
import { COMMON_ACCEPTED_FILE_TYPES, MEGA_BYTE } from 'utils/globalConst';
import labels from 'utils/labels';
import PendingCI from './PendingCI';

export interface RefundDetails {
  numDossier: String;
  dateSurvenance: String;
  numSinistre: String;
  fraisEngagement: String;
  nomMedcinContreVisite: String;
  villeMedcinContreVisite: String;
  statusNum: Number;
  status: String;
  rib: String;
  montantRegle: String;
  modeReglement: String;
  dateEvenement: String;
  adresse: String;
  motif: String;
  maladyDeclarationSuffix?: String;
  hasDepotCI?: boolean;
  codeSouscripteur?: string;
  category?: string;
  policyId?: number;
  policyNumber?: string;
}

interface RefundsType {
  intl: IntlShape;
  refunds: {
    [key: string]: {
      statusApplication: String;
      maladyDeclarationSuffix: String;
      numeroPolicy: string;
      numeroApplication: Number;
      beneficiary: String;
      dateNum: Number;
      years: Number;
      dateOccu: string;
    }[];
  };
  refundDetails: RefundDetails;
  expanded: boolean | String;
  handleChange: Function;
  listIndex: Number;
  isLoading: boolean;
  showEmptyState?: boolean;
}

export interface DocumentParams {
  type: string;
  numeroPolicy: string;
}

const AccordionSinistre = ({
  refunds,
  refundDetails,
  listIndex,
  handleChange,
  expanded,
  isLoading,
  showEmptyState = true,
  ...props
}: RefundsType) => {
  const getUser = useSelector(userSelector);
  const contractAmc = useSelector(getContractAMCSelector);
  const { get: downloadPdf, loading } = useDownloadPdf();
  const [downloadError, setDownloadError] = React.useState('');
  const [complementaryFiles, setComplementaryFiles] = React.useState<any[]>([]);

  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const lang = useSelector(getLocaleSelector);

  const [isFound, setFound] = React.useState<boolean>(false);
  const [checking, setChecking] = React.useState<boolean>(false);
  const [isSending, setSending] = React.useState<boolean>(false);

  const maxCiFiles = parseInt(
    localStorage.getItem(CI_MAX_FILES) ?? DEFAULT_CI_FILES,
  );

  useEffect(() => {
    setDownloadError('');
  }, [expanded]);

  const downloadSinisterDocument = /* istanbul ignore next */ (
    refundDetails: RefundDetails,
    { type, numeroPolicy }: DocumentParams,
  ) => {
    const { numSinistre, codeSouscripteur } = refundDetails;
    setDownloadError('');
    downloadPdf({
      payload: {
        type,
        numeroPolicy,
        numSinistre,
        codeSouscripteur,
      },
      onSuccess: (content: string) =>
        downloadFile(content, `${numSinistre}_${type}.pdf`),
      onError: setDownloadError,
    });
  };

  const checkExist = /* istanbul ignore next */ async () => {
    if (
      refundDetails?.hasDepotCI &&
      !PHYSIQUE_DOCS.includes(refundDetails.motif as string)
    ) {
      setChecking(true);
      const result = await checkExistMissingDocumentsRequestApi({
        sinisterNumber: refundDetails.numSinistre,
        policyId: refundDetails?.policyId,
        LanguageCode: lang,
      });
      setChecking(false);
      if (result?.data?.isSuccess && result?.data?.isFound) {
        setFound(true);
      } else {
        setFound(false);
      }
    }
  };

  const completeClaim = /* istanbul ignore next */ () => {
    openModal();
  };

  const [sortedYears, setSortedYears] = React.useState<string[]>([]);
  const [isOpen, setOpen] = React.useState<boolean>(false);

  useEffect(() => {
    setSortedYears(
      Object.keys(refunds)
        .sort((a, b) => {
          if (a === 'K' || b === 'N') {
            /* istanbul ignore next */
            return -1;
          }
          if (a === 'N' || b === 'K') {
            /* istanbul ignore next */
            return 1;
          }
          return +a - +b;
        })
        .reverse(),
    );
  }, [refunds]);

  const openModal = /* istanbul ignore next */ () => {
    setOpen(true);
  };

  const closeModal = /* istanbul ignore next */ () => {
    setComplementaryFiles([]);
    setOpen(false);
  };

  const getFileName = /* istanbul ignore next */ ({
    uri = '',
    fileName,
  }: any) => {
    if (fileName) return fileName;
    const result = uri.split('/');
    return result[result.length - 1];
  };

  const buildPayload = /* istanbul ignore next */ ({
    images,
    sinisterNumber,
    numDossier,
    maladyDeclarationSuffix,
    policyId,
    id,
    category,
  }: any) => ({
    SinisterNumber: sinisterNumber,
    PolicyId: policyId,
    SinisterDemandTypeCode,
    MaladyDeclarationNumber: numDossier,
    MaladyDeclarationSuffix: maladyDeclarationSuffix,
    LanguageCode: lang,
    AdherentAdhesionNumber: id,
    AdherentAdhesionIdentifier: category,
    Documents: images.map(({ file, data }: any) => ({
      name: getFileName({ uri: file.path, fileName: file.name }),
      uri: file.name,
      type: file.type,
      path: file.name,
      data,
    })),
  });

  const dispatch = useDispatch();

  const onSubmitCI = /* istanbul ignore next */ async () => {
    setSending(true);
    const selectedContractAmc = contractAmc.find(
      (c: any) => c?.NUM_POLICE === refundDetails?.policyNumber,
    );
    let id = getUser?.cin;
    if (getUser?.drpp) {
      id = getUser?.drpp;
    }
    if (selectedContractAmc?.system === 'AS400') {
      id = selectedContractAmc?.numSomme;
    }
    const payload = buildPayload({
      images: complementaryFiles,
      sinisterNumber: refundDetails.numSinistre,
      numDossier: refundDetails.numDossier,
      maladyDeclarationSuffix: refundDetails.maladyDeclarationSuffix,
      policyId: refundDetails.policyId,
      id,
      category: refundDetails?.category,
    });
    const result = await submitCIApi(payload);
    setSending(false);
    closeModal();
    if (result.data.isSuccess) {
      dispatch(
        setToasterOpen({
          message: formatMessage(
            { id: 'claim.ci.submit.success' },
            { id: result?.data?.id },
          ),
          severity: 'success',
        }),
      );
      checkExist();
    } else {
      dispatch(
        setToasterOpen({
          message: result?.data?.warningMessage,
          severity: 'error',
        }),
      );
    }
  };

  const getModalWidth = /* istanbul ignore next */ () => {
    if (isMobile) {
      return '100%';
    }
    return 500;
  };

  const renderDetails = /* istanbul ignore next */ (
    item: any,
    index: Number,
  ) => {
    switch (item.statusApplication) {
      case REFUND_STATUSES.AGREEMENT:
        /* istanbul ignore next */
        return (
          <AgreementClaim
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}-${item.numeroApplication}`}
            onDownloadClick={downloadSinisterDocument}
            loading={loading}
            downloadError={downloadError}
          />
        );
      case REFUND_STATUSES.RETURN:
        /* istanbul ignore next */
        return (
          <RejectedRegulationClaim
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}-${item.numeroApplication}`}
          />
        );
      case REFUND_STATUSES.VISITE:
        /* istanbul ignore next */
        return (
          <ContreVisit
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}-${item.numeroApplication}`}
            onDownloadClick={downloadSinisterDocument}
            loading={loading}
            downloadError={downloadError}
          />
        );
      case REFUND_STATUSES.REJECTED:
        /* istanbul ignore next */
        return (
          <RejectedClaim
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}-${item.numeroApplication}`}
          />
        );
      case REFUND_STATUSES.PAIED:
        /* istanbul ignore next */
        return (
          <ValidatedClaim
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}-${item.numeroApplication}`}
            onDownloadClick={downloadSinisterDocument}
            loading={loading}
            downloadError={downloadError}
          />
        );
      case REFUND_STATUSES.PEC_CANCELED:
        /* istanbul ignore next */
        return (
          <PecCanceledClaim
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}-${item.numeroApplication}`}
          />
        );
      case REFUND_STATUSES.PENDING:
        /* istanbul ignore next */
        return (
          <Pending
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}-${item.numeroApplication}`}
          />
        );
      case REFUND_STATUSES.CI_ENCOURS:
        /* istanbul ignore next */
        return (
          <PendingCI
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}-${item.numeroApplication}`}
          />
        );
      case REFUND_STATUSES.COMPLEMENTARY_INFO:
        /* istanbul ignore next */
        return (
          <ComplementaryInfoClaim
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}-${item.numeroApplication}`}
            onDownloadClick={downloadSinisterDocument}
            loading={loading}
            downloadError={downloadError}
            onCompleteClick={completeClaim}
            checkExist={checkExist}
            isFound={isFound}
            checking={checking}
          />
        );
      case REFUND_STATUSES.PEC:
        /* istanbul ignore next */
        return (
          <PecClaim
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}-${item.numeroApplication}`}
          />
        );
      case REFUND_STATUSES.S_SUITE:
        /* istanbul ignore next */
        return (
          <ClosedClaim
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}-${item.numeroApplication}`}
          />
        );
      default:
        return (
          <Pending
            refund={item}
            refundDetails={refundDetails}
            isLoading={isLoading}
            expanded={expanded}
            index={`refund-${listIndex}-item-${index}-${item.numeroApplication}`}
          />
        );
    }
  };

  return (
    <>
      {sortedYears.length === 0 && showEmptyState ? (
        <StyledCard>
          <StyledGrid
            container
            textAlign="center"
            alignItems="center"
            justify="center"
            marginBottom="17px"
          >
            <ItemEmptyState
              label={translate({ ...messages.emptyState }, props)}
            />
          </StyledGrid>
        </StyledCard>
      ) : (
        sortedYears.map((key) => (
          <>
            <StyledShortBody14>{`${translate(
              get(messages, 'year'),
              props,
            )} ${key}`}</StyledShortBody14>
            {refunds[key]?.map((item: any, index: Number) => {
              return (
                <StyledAccordion
                  color={
                    COLOR_BY_REFUND_STATUS[item.statusApplication] ||
                    COLOR_BY_REFUND_STATUS.DEFAULT
                  }
                  aria-controls={`panel-content-${index}`}
                  id={`panel-header-${index}`}
                  data-testid={`refund-item-${index}`}
                  onChange={handleChange(
                    `refund-${listIndex}-item-${index}-${item.numeroApplication}`,
                    item,
                  )}
                  expanded={
                    expanded ===
                    `refund-${listIndex}-item-${index}-${item.numeroApplication}`
                  }
                >
                  {renderDetails(item, index)}
                </StyledAccordion>
              );
            })}
          </>
        ))
      )}
      <Modal
        open={isOpen}
        handleOpen={openModal}
        handleClose={closeModal}
        header={<Header>{formatMessage(messages.modalHeader)}</Header>}
        content={
          <Box style={{ width: getModalWidth() }} padding={2}>
            <LongBody>{formatMessage(messages.modalDescription)}</LongBody>
            <Box marginTop={3} marginBottom={3}>
              <Grid item xs={12} sm={12} lg={12} style={{ marginBottom: 8 }}>
                <FolderTypeSecondaryContent>
                  {[
                    {
                      icon: 'fileIcon2',
                      title: refundDetails?.motif,
                    },
                  ].map((item) => {
                    /* istanbul ignore next */
                    return (
                      <Grid
                        container
                        style={{ alignItems: 'center' }}
                        spacing={2}
                      >
                        <Grid item xs={2} sm={1}>
                          <img
                            src={AssuranceIcon[item.icon]}
                            alt="optique icon - saham assurance"
                          />
                        </Grid>
                        <Grid
                          style={{ alignSelf: 'center' }}
                          item
                          xs={10}
                          sm={11}
                        >
                          <PrimaryTitleCard>{item.title}</PrimaryTitleCard>
                        </Grid>
                      </Grid>
                    );
                  })}
                </FolderTypeSecondaryContent>
              </Grid>
            </Box>
            <Grid item xs={12} sm={12} lg={12}>
              <StyledDropZoneContainer container justify="flex-start">
                <DropzoneAreaBase
                  fileObjects={complementaryFiles}
                  acceptedFiles={COMMON_ACCEPTED_FILE_TYPES}
                  maxFileSize={20 * MEGA_BYTE}
                  getDropRejectMessage={
                    /* istanbul ignore next */ (file: any, _, maxFileSize) => {
                      if (file.size > maxFileSize) {
                        return formatMessage(
                          {
                            id: labels.fileSizeTooLarge,
                          },
                          { maxFileSize: '20 Mo' },
                        );
                      }
                      return '';
                    }
                  }
                  onAdd={
                    /* istanbul ignore next */ async (newFileObjs) => {
                      const newUploadedDocuments: any[] = [];
                      let i: number = complementaryFiles.length;
                      let totalSize = 0;

                      await asyncForEach(newFileObjs, async (p: FileObject) => {
                        const compressedImage: any = p;
                        if (compressedImage.file.type.includes('image')) {
                          compressedImage.file = await compress(
                            compressedImage.file,
                          );
                          compressedImage.data = await blobToBase64(
                            compressedImage.file,
                          );
                        }

                        newUploadedDocuments.push({
                          ...compressedImage,
                          index: ++i,
                        });
                      });

                      complementaryFiles
                        .concat(newUploadedDocuments)
                        .map((f: any) => (totalSize += f.file.size / 1000000));

                      if (totalSize <= 20) {
                        return setComplementaryFiles(
                          complementaryFiles.concat(newUploadedDocuments),
                        );
                      }
                      alert(
                        formatMessage(
                          {
                            id: labels.fileSizeTooLarge,
                          },
                          { maxFileSize: '20 Mo' },
                        ),
                      );
                      return complementaryFiles;
                    }
                  }
                  onDelete={
                    /* istanbul ignore next */ (deleteFileObj) => {
                      const documents = complementaryFiles?.filter(
                        (document: any) =>
                          document.file.name !== deleteFileObj.file.name,
                      );
                      setComplementaryFiles(documents);
                    }
                  }
                  getPreviewIcon={
                    /* istanbul ignore next */ (file: any) => {
                      const uploadedFile: any = file;
                      return (
                        <ImageWrapper container>
                          <Grid item xs={2}>
                            <img src={get(AssuranceIcon, 'jpeg')} alt="jpeg" />
                          </Grid>
                          <Grid style={{ marginLeft: 5 }} item xs={8} sm={4}>
                            <StyledShortBody color="#616C78" weight="500">
                              {'Document ' + uploadedFile.index}
                            </StyledShortBody>
                            <StyledCaptionsBase>
                              {formatBytes(file.file.size)}
                            </StyledCaptionsBase>
                          </Grid>
                        </ImageWrapper>
                      );
                    }
                  }
                  dropzoneText={formatMessage({
                    id: 'signup_verify_identity.drop_zone_text',
                  })}
                  showPreviewsInDropzone={false}
                  showPreviews={true}
                  previewText=""
                  previewGridProps={{
                    container: {
                      spacing: 2,
                      direction: 'row',
                      dir: 'ltr',
                    },
                    item: {
                      xs: 12,
                    },
                  }}
                  getFileAddedMessage={
                    /* istanbul ignore next */ (fileName: string) => {
                      return (
                        `Document ${complementaryFiles?.length + 1} ` +
                        formatMessage({
                          id: 'amc.file.added',
                        })
                      );
                    }
                  }
                  getFileRemovedMessage={
                    /* istanbul ignore next */ (fileName: string) =>
                      `${fileName} ` +
                      formatMessage({
                        id: 'amc.file.deleted',
                      })
                  }
                  getFileLimitExceedMessage={
                    /* istanbul ignore next */ () =>
                      formatMessage({
                        id: 'amc.droparea.file.limit.exceed.message.1',
                      }) +
                      ` ${maxCiFiles}` +
                      formatMessage({
                        id: 'amc.droparea.file.limit.exceed.message.2',
                      })
                  }
                  filesLimit={maxCiFiles}
                />
              </StyledDropZoneContainer>
            </Grid>
          </Box>
        }
        footer={
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid item>
              <Mention>
                {formatMessage({ id: 'submit.ci.send.mention' })}
              </Mention>
            </Grid>
            <Grid item>
              <OrangeButton
                disabled={complementaryFiles.length === 0 || isSending}
                variant="contained"
                onClick={onSubmitCI}
              >
                {formatMessage(messages.send)}
              </OrangeButton>
            </Grid>
          </Grid>
        }
      />
    </>
  );
};

const Mention = styled(
  /* istanbul ignore next */ ({ reverse, ...otherProps }) => (
    <ShortBody {...otherProps} />
  ),
)`
  &&& {
    line-height: 14px;
    margin-bottom: 0px;
    color: #0075c9;
    font-size: 12px;
    max-width: 400px;
    text-align: justify;
    margin-left: ${/* istanbul ignore next */ (props) =>
      props.reverse ? '12px' : '0px'};
    margin-right: ${/* istanbul ignore next */ (props) =>
      props.reverse ? '0px' : '12px'};
  }
`;
const Header = styled(
  /* istanbul ignore next */ ({ reverse, ...otherProps }) => (
    <ShortBody {...otherProps} />
  ),
)`
  &&& {
    line-height: 16px;
    margin-bottom: 0px;
    color: #0075c9;
    font-weight: bold;
    font-size: 18px;
  }
`;

const FolderTypeSecondaryContent = styled.div`
  background: #ffffff;
  border: 1px solid #eaeaea;
  box-sizing: border-box;
  border-radius: 13.5px;
  width: 100%;
  overflow: auto;
  height: auto;
  padding: 15px;
  align-items: center;
  @media (max-width: ${breakpoints.xs}) {
    width: 90%;
  }
`;

const mapStateToProps = createStructuredSelector<
  any,
  {
    refundDetails: {
      numDossier: String;
      dateSurvenance: String;
      numSinistre: String;
      fraisEngagement: String;
      nomMedcinContreVisite: String;
      villeMedcinContreVisite: String;
      statusNum: Number;
      status: String;
      rib: String;
      montantRegle: String;
      modeReglement: String;
      dateEvenement: String;
      adresse: String;
      motif: String;
    };
  }
>({
  refundDetails: getRefundAMCDetailsSelector,
});
const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(AccordionSinistre));
